(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sjelf-curated-artists"] && !Shopify.designMode) return;
  try {
    (() => {
 const norm=value=>String(value||'').normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/\$/g,'s').replace(/[^a-z0-9]+/g,' ').trim();
 function init(root){
  if(root.dataset.ready)return;root.dataset.ready='true';
  const input=root.querySelector('[data-search]'),clear=root.querySelector('[data-clear]'),letters=root.querySelector('[data-letters]'),status=root.querySelector('[data-status]'),allResults=root.querySelector('[data-all-results]');
  const groups=[...root.querySelectorAll('[data-curated-group]')].map(node=>({node,letter:node.dataset.curatedGroup,artists:[...node.querySelectorAll('[data-curated-artist]')].map(link=>({link,search:norm(link.dataset.searchText)}))}));
  const total=groups.reduce((n,g)=>n+g.artists.length,0),format=new Intl.NumberFormat('nl-NL');
  let selected='all';
  function render(){
   const terms=norm(input.value).split(' ').filter(Boolean);let shown=0;
   for(const group of groups){let count=0;for(const artist of group.artists){const visible=(selected==='all'||group.letter===selected)&&terms.every(term=>artist.search.includes(term));artist.link.hidden=!visible;if(visible)count++;}group.node.hidden=count===0;shown+=count;}
   letters.querySelectorAll('[data-letter]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.letter===selected)));
   clear.hidden=!input.value;allResults.hidden=!input.value.trim();
   const url=new URL(input.form.action,location.origin);url.searchParams.set('q',input.value.trim());url.searchParams.set('type','product,article,page');allResults.href=url.pathname+url.search;
   status.textContent=shown?root.dataset.statusCount.replace('[shown]',format.format(shown)).replace('[total]',format.format(total)):root.dataset.statusEmpty;
   root.dataset.visibleCount=String(shown);root.dataset.count=String(total);root.dataset.complete='true';
  }
  letters.hidden=false;
  letters.querySelectorAll('[data-letter]').forEach(button=>{button.disabled=button.dataset.letter!=='all'&&!groups.some(group=>group.letter===button.dataset.letter);});
  input.addEventListener('input',()=>{selected='all';render();});
  clear.addEventListener('click',()=>{input.value='';selected='all';input.dispatchEvent(new Event('input',{bubbles:true}));input.focus();});
  letters.addEventListener('click',event=>{const button=event.target.closest('[data-letter]');if(!button||button.disabled)return;input.value='';input.dispatchEvent(new Event('input',{bubbles:true}));selected=button.dataset.letter;render();});
  render();
 }
 const all=()=>document.querySelectorAll('[data-curated-directory]').forEach(init);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
 document.addEventListener('shopify:section:load',all);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sjelf-product-build"] && !Shopify.designMode) return;
  try {
    (async () => {
    const { StandardEvents } = await import('@shopify/events');
    if (customElements.get('sjelf-product-build')) return;
    customElements.define('sjelf-product-build', class extends HTMLElement {
      connectedCallback() {
        this.listeners?.abort();
        this.listeners = new AbortController();
        document.addEventListener(StandardEvents.cartLinesUpdate, async (event) => {
          try {
            if (event.promise) {
              const result = await event.promise;
              if (result?.detail?.didError) return;
            }
            if (this.isConnected) this.refresh();
          } catch {}
        }, { signal: this.listeners.signal });
        window.addEventListener('pageshow', (event) => {
          if (event.persisted) this.refresh();
        }, { signal: this.listeners.signal });
      }
      disconnectedCallback() {
        this.listeners?.abort();
        this.request?.abort();
      }
      async refresh() {
        this.request?.abort();
        const request = this.request = new AbortController();
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url, { signal: request.signal, cache: 'no-store' });
          if (!response.ok) return;
          const html = await response.text();
          if (request.signal.aborted || !this.isConnected) return;
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const next = parsed.querySelector('sjelf-product-build [data-build-content]');
          const nextNature = parsed.querySelector('sjelf-product-build [data-nature-tiers]');
          const currentNature = this.querySelector('[data-nature-tiers]');
          if (nextNature && currentNature) currentNature.innerHTML = nextNature.innerHTML;
          const current = this.querySelector('[data-build-content]');
          if (!next || !current) return;
          const oldBar = current.querySelector('.sjelf-product-build__track > span');
          const oldWidth = oldBar?.style.width || '0%';
          current.innerHTML = next.innerHTML;
          const bar = current.querySelector('.sjelf-product-build__track > span');
          if (bar) {
            const width = bar.style.width;
            bar.style.width = oldWidth;
            requestAnimationFrame(() => requestAnimationFrame(() => { bar.style.width = width; }));
          }
        } catch {}
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sjelf-search-suggestions"] && !Shopify.designMode) return;
  try {
    (() => {
 const config=document.getElementById('sjelf-suggest-config');
 if(!config)return;
 const copyByLocale={"nl":{"panel":"Artiesten en albums","via":"Gevonden via: ","artist":"Artiest · Alle platen en verhalen","discover":"ONTDEK DE ARTIEST.","all":"Alle platen en verhalen op één plek.","match":"Deze artiesten passen bij je zoekopdracht.","cta":"ONTDEK ","label":"Ontdek de artiest"},"en":{"panel":"Artists and albums","via":"Found through: ","artist":"Artist · All records and stories","discover":"DISCOVER THE ARTIST.","all":"All records and stories in one place.","match":"These artists match your search.","cta":"DISCOVER ","label":"Discover the artist"},"de":{"panel":"Künstler und Alben","via":"Gefunden über: ","artist":"Künstler · Alle Platten und Geschichten","discover":"ENTDECKE DEN KÜNSTLER.","all":"Alle Platten und Geschichten an einem Ort.","match":"Diese Künstler passen zu deiner Suche.","cta":"ENTDECKE ","label":"Entdecke den Künstler"},"fr":{"panel":"Artistes et albums","via":"Trouvé via : ","artist":"Artiste · Tous les disques et récits","discover":"DÉCOUVREZ L’ARTISTE.","all":"Tous les disques et récits au même endroit.","match":"Ces artistes correspondent à votre recherche.","cta":"DÉCOUVREZ ","label":"Découvrez l’artiste"},"da":{"panel":"Kunstnere og album","via":"Fundet via: ","artist":"Kunstner · Alle plader og fortællinger","discover":"OPDAG KUNSTNEREN.","all":"Alle plader og fortællinger ét sted.","match":"Disse kunstnere matcher din søgning.","cta":"OPDAG ","label":"Opdag kunstneren"}};
 const ui=copyByLocale[document.documentElement.lang.split('-')[0]]||copyByLocale.nl;
 const norm=s=>String(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();
 const catalog=new Map(),queries=new Map();
 const safePath=(value,part)=>{try{const u=new URL(value,location.origin);return u.origin===location.origin&&u.pathname.includes(part)?u.pathname:null;}catch(e){return null;}};
 function rank(artist,q){
  let best=0;const terms=q.split(' ');
  for(const name of artist.names){
   const short=name.replace(/^the /,'');
   if(name===q||short===q)best=Math.max(best,100);
   else if(name.startsWith(q)||short.startsWith(q))best=Math.max(best,80);
   else if(terms.every(t=>name.split(' ').some(w=>w.startsWith(t))))best=Math.max(best,60);
  }
  return best;
 }
 function localMatches(q){return [...catalog.values()].map(a=>({...a,score:rank(a,q)})).filter(a=>a.score>0).sort((a,b)=>b.score-a.score||a.title.localeCompare(b.title)).slice(0,5);}
 async function albums(q){
  const u=new URL(config.dataset.url,location.origin);u.searchParams.set('section_id','sjelf-predictive-data');u.searchParams.set('q',q);u.searchParams.set('resources[type]','product');u.searchParams.set('resources[limit]','10');u.searchParams.set('resources[options][fields]','title,vendor');u.searchParams.set('resources[options][unavailable_products]','show');
  const r=await fetch(u,{signal:AbortSignal.timeout(8000)});if(!r.ok)throw Error('Search unavailable');
  const doc=new DOMParser().parseFromString(await r.text(),'text/html');
  return [...doc.querySelectorAll('#sjelf-predictive-data a[data-kind="products"]')].map(a=>({title:a.textContent.trim(),vendor:a.dataset.vendor,handle:a.dataset.handle,url:safePath(a.getAttribute('href'),'/products/'),artistUrl:safePath(a.dataset.artistUrl,'/pages/artists/')})).filter(p=>p.url);
 }
 async function resolve(raw){
  const q=norm(raw);if(q.length<2)return[];
  if(queries.has(q))return queries.get(q);
  const work=(async()=>{
   const found=await albums(raw);
   for(const p of found){
    if(!p.vendor||!p.artistUrl)continue;
    catalog.set(p.artistUrl,{kind:'artist',url:p.artistUrl,title:p.vendor.toUpperCase(),canonical:p.vendor,names:[norm(p.vendor)]});
   }
   const artists=localMatches(q);
   // An album query can also lead to its artist's full collection.
   if(!artists.length){for(const p of found){if(!p.artistUrl||artists.some(a=>a.url===p.artistUrl))continue;artists.push({...catalog.get(p.artistUrl),score:40,album:p.title,handle:p.handle});if(artists.length===2)break;}}
   const products=found.slice(0,4).map(p=>({...p,kind:'product',score:20}));
   return [...artists.slice(0,4),...products];
  })();
  if(queries.size>=40)queries.delete(queries.keys().next().value);
  queries.set(q,work);work.catch(()=>queries.delete(q));return work;
 }
 const destination=row=>row.kind==='artist'&&row.handle?row.url+'?sjelf_album='+encodeURIComponent(row.handle)+'#artist-vinyl':row.url;
 window.SjelfArtistSearch={resolve};
 function setup(){
  document.querySelectorAll('.sjelf-header-search input[name="q"],.sjelf-vinyl__search input[name="q"],[data-sjelf-directory] [data-search]').forEach((input,i)=>{
   if(input.dataset.sjelfSuggest)return;input.dataset.sjelfSuggest='true';
   const label=document.querySelector('label[for="'+input.id+'"]');if(label?.classList.contains('visually-hidden'))label.textContent=input.placeholder;
   const panel=document.createElement('div');panel.className='sjelf-suggest-panel';panel.id=(input.id||'ArtistSearch'+i)+'-suggestions';panel.hidden=true;panel.setAttribute('role','listbox');panel.setAttribute('aria-label',ui.panel);document.body.append(panel);
   input.setAttribute('role','combobox');input.setAttribute('aria-autocomplete','list');input.setAttribute('aria-controls',panel.id);input.setAttribute('aria-expanded','false');
   let timer,revision=0,active=-1;
   const close=()=>{panel.hidden=true;active=-1;input.setAttribute('aria-expanded','false');input.removeAttribute('aria-activedescendant');};
   const cancel=()=>{revision++;clearTimeout(timer);close();};
   const place=()=>{const r=(input.form||input.parentElement).getBoundingClientRect();const width=Math.min(Math.max(r.width,280),innerWidth-16);panel.style.left=Math.max(8,Math.min(r.left,innerWidth-width-8))+'px';panel.style.top=r.bottom+'px';panel.style.width=width+'px';};
   input.addEventListener('input',()=>{
    cancel();const ticket=revision,q=input.value.trim();if(norm(q).length<2)return;
    timer=setTimeout(async()=>{
     try{
      const rows=await resolve(q);if(ticket!==revision||document.activeElement!==input)return;
      input.dispatchEvent(new CustomEvent('sjelf:artist-results',{detail:rows}));
      panel.replaceChildren();
      for(const row of rows){
       const link=document.createElement('a');link.href=destination(row);link.id=panel.id+'-'+panel.children.length;link.setAttribute('role','option');link.setAttribute('aria-selected','false');link.tabIndex=-1;
       const title=document.createElement('span');title.textContent=row.title;link.append(title);
       const subtitle=document.createElement('small');subtitle.textContent=row.kind==='product'?'Album · '+row.vendor:(row.album?ui.via+row.album:ui.artist);link.append(subtitle);panel.append(link);
      }
      if(rows.length){place();panel.hidden=false;input.setAttribute('aria-expanded','true');}
     }catch(e){if(ticket===revision)close();}
    },100);
   });
   input.addEventListener('keydown',e=>{
    if(e.key==='Escape'){cancel();return;}
    if(!panel.hidden&&(e.key==='ArrowDown'||e.key==='ArrowUp')){
     e.preventDefault();active=(active+(e.key==='ArrowDown'?1:-1)+panel.children.length)%panel.children.length;
     [...panel.children].forEach((a,n)=>a.setAttribute('aria-selected',String(n===active)));
     input.setAttribute('aria-activedescendant',panel.children[active].id);panel.children[active].scrollIntoView({block:'nearest'});
    }
    if(e.key==='Enter'){
     if(!panel.hidden&&active>=0){e.preventDefault();panel.children[active].click();}
     else if(!input.form){e.preventDefault();const u=new URL(config.dataset.search,location.origin);u.searchParams.set('q',input.value);u.searchParams.set('type','product,article,page');location.assign(u);}
    }
    if(e.key==='Tab')cancel();
   });
   input.addEventListener('blur',()=>setTimeout(()=>{if(!panel.contains(document.activeElement))cancel();},180));
   input.form?.addEventListener('submit',cancel);
   document.addEventListener('pointerdown',e=>{if(e.target!==input&&!panel.contains(e.target))cancel();});
   window.addEventListener('resize',close);window.addEventListener('scroll',close,{passive:true});
  });
 }
 async function searchDestination(){
  if(!location.pathname.endsWith('/search'))return;
  const q=new URL(location.href).searchParams.get('q');if(!q)return;
  try{
   const rows=(await resolve(q)).filter(r=>r.kind==='artist');if(!rows.length||document.querySelector('.sjelf-search-artist'))return;
   const exact=rows.filter(r=>r.score===100),choices=exact.length?exact:rows.slice(0,3);
   const block=document.createElement('section');block.className='sjelf-search-artist';block.setAttribute('aria-label',ui.label);
   const copy=document.createElement('div'),heading=document.createElement('h2'),text=document.createElement('p'),links=document.createElement('div');links.className='sjelf-search-artist__links';
   heading.textContent=choices.length===1?choices[0].title:ui.discover;
   text.textContent=choices.length===1?(choices[0].album?ui.via+choices[0].album:ui.all):ui.match;
   copy.append(heading,text);block.append(copy,links);
   choices.forEach(row=>{const a=document.createElement('a');a.href=destination(row);a.textContent=ui.cta+row.title+' →';links.append(a);});
   const intro=document.querySelector('.sjelf-search-results__intro'),results=document.querySelector('#ResultsList');
   if(intro)intro.after(block);else if(results)results.prepend(block);else document.querySelector('#MainContent')?.prepend(block);
  }catch(e){}
 }
 function focusAlbum(){
  if(!location.pathname.includes('/pages/artists/'))return;
  const handle=new URL(location.href).searchParams.get('sjelf_album');if(!handle||!/^[a-z0-9-]+$/.test(handle))return;
  const region=document.getElementById('artist-vinyl');if(!region)return;
  const link=[...region.querySelectorAll('a[href]')].find(a=>new URL(a.href).pathname==='/products/'+handle);
  const card=link?.closest('li');if(card){card.classList.add('sa-search-match');requestAnimationFrame(()=>card.scrollIntoView({block:'center',behavior:'instant'}));}
 }
 function start(){setup();searchDestination();focusAlbum();}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
 document.addEventListener('shopify:section:load',setup);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sjelf-topic-filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown', function(event) {
    const option = event.target.closest('[data-topic-checkbox]');
    if (option && event.key === ' ') {
      event.preventDefault();
      option.click();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sjelf-webwinkelkeur"] && !Shopify.designMode) return;
  try {
    function styleSjelfFooterReviews() {
    document.querySelectorAll('.sjelf-wwk-strip .sjelf-wwk-reviews valued-widget').forEach((widget) => {
      let attempts = 0;
      const apply = () => {
        const root = widget.shadowRoot;
        if (!root || !root.querySelector('.review')) {
          if (++attempts < 40 && widget.isConnected) setTimeout(apply, 250);
          return;
        }
        if (root.querySelector('[data-sjelf-review-style]')) return;
        const style = document.createElement('style');
        style.setAttribute('data-sjelf-review-style', '');
        style.textContent = '.widget-reviews-footer{display:none!important}.reviews-widget{background:transparent!important;border:0!important}.review{border:0!important;border-radius:10px!important;background:#fff!important;min-height:0!important;height:auto!important;padding:22px 24px!important}.reviews-carousel{margin:0!important}.content{min-height:0!important}.swiper-button-lock{display:none!important}';
        root.appendChild(style);
      };
      apply();
    });
  }
  styleSjelfFooterReviews();
  document.addEventListener('shopify:section:load', styleSjelfFooterReviews);
  } catch(e) { console.error(e); }
})();

})();
